import {
  CollectionName,
  CollectionVisibility,
} from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const euWineIngredientsSchema: CollectionCreateSchema = {
  name: CollectionName.EUIngredients,
  fields: [
    {
      name: "ingredient",
      type: "string",
      infix: true,
      sort: true,
    },
    {
      name: "functional_category",
      type: "string",
      optional: true,
      infix: true,
      sort: true,
    },
    {
      name: "e_number",
      type: "string",
      optional: true,
      infix: true,
      sort: true,
    },
    {
      name: "allergen",
      type: "bool",
      optional: true,
    },
    {
      name: "priority",
      type: "int32",
      sort: true,
      optional: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
